/** @format */

import React from 'react'

export const Icon = ({ name = '', onClick = () => null, style = {} }) => {
  const path = require(`../../assets/icons_png/${name}.png`)

  return (
    <img src={path.default} alt={name} className={style} onClick={onClick} />
  )
}
